<template>
    <div class="rounded-lgr p-6 new-home-card border-2 border-valence-grey-250 bg-gradient-to-r from-[#ac93c2] via-[#7065cb] via-30% to-[#a68acb]">
        <div class="flex flex-col gap-4">
            <!-- Top: Title and CTA button -->
            <div class="flex items-center justify-between gap-4">
                <h3 class="title-section text-white">Keep the Momentum Going</h3>
                <button class="shrink-0 bg-white/80 hover:bg-white text-valence-primary-500 font-medium px-6 py-2.5 rounded-full transition-colors" @click="handleWrappedClick">
                    View
                </button>
            </div>
            <p class="body-small text-white/80">Discover 3 things you didn't know about yourself</p>
        </div>
    </div>
</template>

<script setup>
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const { wrappedUrl, cardType, wrappedYear } = defineProps({
    wrappedUrl: { type: String, default: "/wrapped/" },
    cardType: { type: String, required: true },
    wrappedYear: { type: Number, required: true },
});

const handleWrappedClick = () => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_REVIEWED_CARD_CLICKED, { year: wrappedYear });
    openUrl(wrappedUrl);
};

onMounted(() => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_CARD_SHOWN, { card_type: cardType });
});
</script>
